<div>
  <div class="grid-container">
    <div class="grid-row">
      <div class="description fw-bold">Valeur estimée avec +/- values</div>
    </div>
  </div>

  <div class="grid-container ms-5">
    <div class="grid-row text-primary fw-bold">
      <div class="description">Estimation</div>
      <div class="value">
        {{
          appraisal.appraisedValueWithAddedReducedValues
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
    </div>
  </div>

  <div class="grid-container ms-5">
    <div class="grid-row">
      <div class="description">
        Estimation basse
        <p-percentage-label
          [percentage]="appraisal.lowEstimatePercentageWithAddedReducedValues"
        ></p-percentage-label>
      </div>
      <div class="value">
        {{
          appraisal.lowEstimateWithAddedReducedValues
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
    </div>
  </div>

  <div class="grid-container ms-5">
    <div class="grid-row">
      <div class="description">
        Estimation haute
        <p-percentage-label
          [percentage]="
            appraisal.highwayAccessEstimatePercentageWithAddedReducedValues
          "
        ></p-percentage-label>
      </div>
      <div class="value">
        {{
          appraisal.highEstimateWithAddedReducedValues
            | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
        }}
      </div>
    </div>
  </div>
</div>
